module.exports = __webpack_public_path__ + "static/media/cv_original.88dd53aa.jpg";